/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
class e {
  /**
   * @hidden
   */
  constructor(t) {
    this.target = t;
  }
}
export {
  e as BaseEvent
};
